// extracted by mini-css-extract-plugin
module.exports = {"profileLink":"profileLink__14EDq","textarea":"textarea__19qUA","sendInvite":"sendInvite__-6cUJ"};